import React from 'react';

export const IpamorelinDiagram: React.FC = () => {
  return (
    <div className="w-full max-w-4xl mx-auto diagram-container">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 800 600" 
        className="w-full h-auto"
      >
        {/* Main background */}
        <rect x="0" y="0" width="800" height="600" fill="#f8fafc" rx="5" ry="5" />
        
        {/* Title */}
        <text x="400" y="40" textAnchor="middle" fontSize="24" fontWeight="bold" fill="#334155">
          Ipamorelin Mechanism of Action
        </text>
        
        {/* Brain/Pituitary */}
        <ellipse cx="400" cy="130" rx="120" ry="60" fill="#f1f5f9" stroke="#64748b" strokeWidth="2" />
        <text x="400" y="120" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#334155">
          Hypothalamus/Pituitary
        </text>
        <text x="400" y="145" textAnchor="middle" fontSize="14" fill="#64748b">
          GHSR-1a Receptors
        </text>
        
        {/* Ipamorelin binding */}
        <rect x="150" y="100" width="100" height="40" rx="20" ry="20" fill="#a78bfa" stroke="#7c3aed" strokeWidth="2" />
        <text x="200" y="125" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white">
          Ipamorelin
        </text>
        <path d="M250 120 L300 130" stroke="#7c3aed" strokeWidth="2" markerEnd="url(#arrowhead)" />
        
        {/* GH Secretion */}
        <path 
          d="M400 190 L400 270" 
          stroke="#64748b" 
          strokeWidth="3" 
          markerEnd="url(#arrowhead)"
          strokeDasharray="5,5"
        />
        <text x="410" y="230" textAnchor="start" fontSize="14" fontWeight="bold" fill="#334155">
          GH Release
        </text>
        
        {/* Liver/IGF-1 */}
        <rect x="300" y="270" width="200" height="60" rx="5" ry="5" fill="#e0f2fe" stroke="#0369a1" strokeWidth="2" />
        <text x="400" y="300" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#0369a1">
          Liver: IGF-1 Production
        </text>
        <path 
          d="M400 330 L400 380" 
          stroke="#0369a1" 
          strokeWidth="2" 
          markerEnd="url(#arrowhead)" 
        />
        
        {/* Systemic effects */}
        <rect x="100" y="380" width="200" height="60" rx="5" ry="5" fill="#dcfce7" stroke="#16a34a" strokeWidth="2" />
        <text x="200" y="410" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#16a34a">
          Anabolic Effects
        </text>
        <text x="200" y="430" textAnchor="middle" fontSize="12" fill="#16a34a">
          Protein synthesis, Muscle growth
        </text>
        
        <rect x="320" y="380" width="160" height="60" rx="5" ry="5" fill="#fee2e2" stroke="#dc2626" strokeWidth="2" />
        <text x="400" y="410" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#dc2626">
          Lipolysis
        </text>
        <text x="400" y="430" textAnchor="middle" fontSize="12" fill="#dc2626">
          Fat reduction
        </text>
        
        <rect x="500" y="380" width="200" height="60" rx="5" ry="5" fill="#dbeafe" stroke="#2563eb" strokeWidth="2" />
        <text x="600" y="410" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#2563eb">
          Tissue Repair
        </text>
        <text x="600" y="430" textAnchor="middle" fontSize="12" fill="#2563eb">
          Recovery, Healing
        </text>
        
        {/* Unique feature */}
        <rect x="480" y="100" width="170" height="60" rx="5" ry="5" fill="#fef3c7" stroke="#d97706" strokeWidth="2" />
        <text x="565" y="125" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#d97706">
          Minimal effect on:
        </text>
        <text x="565" y="145" textAnchor="middle" fontSize="12" fill="#d97706">
          Cortisol & Prolactin
        </text>
        
        {/* Arrow definitions */}
        <defs>
          <marker 
            id="arrowhead" 
            markerWidth="10" 
            markerHeight="7" 
            refX="9" 
            refY="3.5" 
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="#64748b" />
          </marker>
        </defs>
      </svg>
    </div>
  );
};